import { css } from '@emotion/react';
import { divide, percentage } from '../_functions';


export default $ => css`
  .embed-responsive {
    position: relative;
    display: block;
    width: 100%;
    padding: 0;
    overflow: hidden;

    &::before {
      display: block;
      content: "";
    }

    .embed-responsive-item,
    iframe,
    embed,
    object,
    video {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }
  }

  ${$.embedResponsiveAspectRatios.map(([x, y]) => css`
    .embed-responsive-${x}by${y}::before {
      padding-top: ${percentage(divide(y, x))}%;
    }
  `)}
`;
